<template>
  <div>
    <div>
      <el-button @click="allpassPdf" type="primary" :disabled="!canBatchOperate">批量通过</el-button>
      <el-button @click="allblackPdf" type="primary" :disabled="!canBatchOperate">批量退回</el-button>
      <div style="margin-top: 20px;">
        <el-table
          ref="multipleTable"
          :data="trustTableData"
          style="width: 100%;"
          @selection-change="handleSelectionChange"
          :row-key="getRowKey"
        >
          <el-table-column type="selection" width="55" :selectable="isSelectable"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="enterpriseName" label="名称">
            <template slot-scope="{ row }">
              <span>{{ row.enterpriseName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="上传时间">
            <template slot-scope="{ row }">
              <span>{{ row.createTime }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="auditStatus" label="状态">
            <template slot-scope="{ row }">
              <span>{{ row.auditStatus }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="{ row }">
              <el-button :disabled="!isPending(row)" @click="rowkeypassPdf(row)" type="text"><i class="el-icon-check" size="16" style="font-size:16px;color: green;font-weight: 600;"></i></el-button>
              <el-button :disabled="!isPending(row)" @click="rowkeyblackPdf(row)" type="text"><i class="el-icon-close" style="font-size:16px;color: red;font-weight: 600;"></i></el-button>
              <el-button @click="downPdf(row)" type="text">下载</el-button>
              <el-button @click="previewPdf(row)" type="text">预览</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div style="text-align: right; margin-top:30px;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 40,50]"
          :page-size="100"
          layout="total, sizes, prev, pager, next, jumper"
          :total="trustTotal"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { bankList, cerditCentePass } from "../../../api/bankcrecenter.js";
import baseUrl from "@/api/baseUrl";
export default {
  data() {
    return {
      fileArray: [],
      bankTitle: "",
      selectedItems: [], // 所有选中的项目（包括已审核的）
      selectedPendingItems: [], // 仅选中的待审核项目
      batchLoading: false,
      //   actionType: "", // 'approve' or 'reject'
      bankFromPage: {
        page: 1,
        pageSize: 10
      },
      trustTotal: null,
      // dialogUpload: false,
      modeUploadForm: {},
      // 信用中心
      trustTableData: []
    };
  },
  computed: {
    // 是否可以执行批量操作
    canBatchOperate() {
      return this.selectedPendingItems.length > 0 && !this.batchLoading;
    }
  },
  mounted() {
    this.trustData();
  },
  methods: {
    // 获取审批列表
    async trustData() {
      try {
        const res = await bankList(this.bankFromPage);
        this.trustTableData = res.data.data || [];
        this.trustTotal = res.data.pageInfo.total;
        this.clearInvalidSelections();
      } catch (error) {
        // this.$message.error(error.message || "获取数据失败");
      } finally {
        // this.loading = false;
      }
    },

    // 清除无效的选择
    clearInvalidSelections() {
      this.$nextTick(() => {
        const invalidSelections = this.selectedItems.filter(
          item => !this.isPending(item)
          // console.log(this.item, "invalidSelections")
        );

        if (invalidSelections.length > 0) {
          invalidSelections.forEach(item => {
            this.$refs.multipleTable.toggleRowSelection(item, false);
          });
          this.selectedItems = this.selectedItems.filter(item =>
            this.isPending(item)
          );
        }
      });
    },

    // 获取行唯一标识
    getRowKey(row) {
      return row.id;
    },
    // 判断是否是pending状态
    isPending(row) {
      return row.auditStatus == "待审核";
    },
    // 判断行是否可选
    isSelectable(row) {
      //   return row.auditStatus == 0;
      return this.isPending(row);
    },
    // 选择项变化
    handleSelectionChange(val) {
      this.selectedItems = val;
      // 筛选出待审核的项目
      this.selectedPendingItems = val.filter(
        item => item.auditStatus == "待审核"
      );
    },
    // 单个通过
    async rowkeypassPdf(row) {
      try {
        const res = await cerditCentePass({
          auditStatus: "通过",
          ids: [row.id]
        });
        if (res.data.code == 200) {
          this.$message.success(`已通过: ${row.enterpriseName}`);
        }
        this.trustData();
      } catch (error) {
        this.$message.error(error.message || "操作失败");
      }
    },
    // 单个拒绝
    async rowkeyblackPdf(row) {
      try {
        const res = await cerditCentePass({
          auditStatus: "退回",
          ids: [row.id]
        });
        if (res.data.code == 200) {
          this.$message.error(`已退回: ${row.enterpriseName}`);
        }
        this.trustData();
      } catch (error) {
        this.$message.error(error.message || "操作失败");
      }
    },
    // 下载
    downPdf(row) {
      // 编码转译
      const encodedPath = encodeURIComponent(row.licensePath);
      const xhr = new XMLHttpRequest();
      xhr.open(
        "get",
        this.baseUrl +
          `/api/v1/bankLicense/downloadFile?licensePath=${encodedPath}`,
        true
      ); // get、post都可
      xhr.responseType = "blob"; // 转换流
      xhr.setRequestHeader("token", sessionStorage.getItem("token")); // token键值对
      xhr.onload = function() {
        if (this.status === 200) {
          const blob = this.response;
          const fileName = row.licensePath;
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            const a = document.createElement("a");
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
          }
        }
      };
      xhr.send();
    },
    // 预览
    previewPdf(row) {
      const encodedPath = encodeURIComponent(row.licensePath);
      const xhr = new XMLHttpRequest();
      xhr.open(
        "get",
        this.baseUrl +
          `/api/v1/bankLicense/downloadFile?licensePath=${encodedPath}`,
        true
      );
      xhr.responseType = "blob";
      xhr.setRequestHeader("token", sessionStorage.getItem("token"));
      xhr.onload = () => {
        const blob = xhr.response;
        console.log("[预览调试] HTTP状态:", xhr.status, "Content-Type:", xhr.getResponseHeader("Content-Type"), "Blob大小:", blob.size);

        const reader = new FileReader();
        reader.onload = () => {
          const text = reader.result;
          console.log("[预览调试] Blob前200字:", text.substring(0, 200));

          if (xhr.status === 200) {
            const contentType = xhr.getResponseHeader("Content-Type") || "";
            if (contentType.includes("application/json") || contentType.includes("xml") || text.trim().startsWith("{") || text.trim().startsWith("<")) {
              let errMsg = text;
              try { errMsg = JSON.parse(text).msg || JSON.parse(text).message || text; } catch(e) {}
              this.$message.error("后端返回了错误: " + errMsg);
              return;
            }
            const url = window.URL.createObjectURL(blob);
            const win = window.open(url, "_blank");
            if (!win) {
              this.$message.warning("浏览器拦截了新窗口，请允许弹窗后重试");
            }
            setTimeout(() => window.URL.revokeObjectURL(url), 60000);
          } else {
            let errMsg = text;
            try { errMsg = JSON.parse(text).msg || JSON.parse(text).message || text; } catch(e) {}
            this.$message.error("预览失败: HTTP " + xhr.status + " - " + errMsg);
          }
        };
        reader.readAsText(blob);
      };
      xhr.onerror = () => {
        this.$message.error("网络错误，无法预览");
      };
      xhr.send();
    },
    // 批量通过
    allpassPdf() {
      this.$confirm(
        `确定要通过选中的 ${this.selectedItems.length} 个项目吗?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(async () => {
          this.batchLoading = true;
          //   this.actionType = "reject";
          try {
            const ids = this.selectedItems.map(item => item.id);
            const res = await cerditCentePass({
              auditStatus: "通过",
              ids
            });
            if (res.data.code == 200) {
              this.$message.success(
                `已批量通过 ${this.selectedItems.length} 项`
              );
            }
            this.$refs.multipleTable.clearSelection();
            this.trustData();
          } catch (error) {
            this.$message.error(error.message || "批量操作失败");
          } finally {
            this.batchLoading = false;
            // this.actionType = "";
          }
        })
        .catch(() => {
          this.$message.info("已取消操作");
        });
    },
    //批量退回
    allblackPdf() {
      this.$confirm(
        `确定要拒绝选中的 ${this.selectedItems.length} 个项目吗?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(async () => {
          this.batchLoading = true;
          //   this.actionType = "reject";
          try {
            const ids = this.selectedItems.map(item => item.id);
            const res = await cerditCentePass({
              auditStatus: "退回",
              ids
            });
            if (res.data.code == 200) {
              this.$message.error(`已批量拒绝 ${this.selectedItems.length} 项`);
            }
            this.$refs.multipleTable.clearSelection();
            this.trustData();
          } catch (error) {
            this.$message.error(error.message || "批量操作失败");
          } finally {
            this.batchLoading = false;
            // this.actionType = "";
          }
        })
        .catch(() => {
          this.$message.info("已取消操作");
        });
    },
    // 分页
    handleSizeChange(val) {
      this.bankFromPage.pageSize = val;
      this.trustData(this.bankFromPage);
    },
    handleCurrentChange(val) {
      this.bankFromPage.page = val;
      this.trustData(this.bankFromPage);
    }
  }
};
</script>

<style>
</style>